import React from "react";
import { useState } from "react";
import Banner from "./Banner";
import Footer from "./Footer";
import International from "./InternationalAward";
import IndiaBrandIcon from "./IndiaBrandIcon";
import LeadershipAwards from "./LeadershipAwards";
import Indiaicon from "./Indiaicon";



const Other_Award = () => {
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
  return (
    <>
      <Banner />
      <div className="other_btn">
        <button onClick={()=>setShow(true)}>International Healthcare Awards</button>
        <button onClick={()=>setShow(false)}>India Brand Icon Awards</button>
      </div>

      {show ? <International/> : <IndiaBrandIcon/>}

      <div className="other1_btn">
        <button onClick={()=>setShow1(true)}>International Leadership Awards</button>
        <button onClick={()=>setShow1(false)}>Indian Icon of the year Awards</button>
      </div>

      {show1 ? <LeadershipAwards/> : <Indiaicon/>}

      <Footer />
    </>
  );
};

export default Other_Award;
